import { useLicense } from '@vue-pdf-viewer/viewer'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const domainToken = config.public.vpvDomainToken
  
  if (domainToken) {
    console.log('Initializing Vue PDF Viewer license')
    useLicense(domainToken, nuxtApp.vueApp)
  } else {
    console.warn('No VPV domain token found in runtime config')
  }
})